export const sideBarOpener = (value) => ({
    type: "SIDEBAR_OPENER",
    payload: value,
});